import { Mail, MapPin, Clock } from "lucide-react";
import { PageHeader, Reveal } from "@/components/site/Reveal";
import ContactForm from "@/components/site/ContactForm";
import { CONTACT_EMAIL } from "@/data/site";

const INFO = [
    {
        icon: Mail,
        label: "Email",
        value: CONTACT_EMAIL,
        note: "Placeholder — replace once configured",
        href: `mailto:${CONTACT_EMAIL}`,
    },
    {
        logo: "upwork",
        label: "Upwork",
        value: "Agency Profile",
        note: "Shopify & web development — link to be added",
    },
    {
        icon: MapPin,
        label: "Location",
        value: "India · Working Worldwide",
        note: "Remote-first delivery across time zones",
    },
    {
        icon: Clock,
        label: "Response",
        value: "Within 1–2 business days",
        note: "Every enquiry gets a considered reply",
    },
];

export default function ContactPage() {
    return (
        <div data-testid="contact-page">
            <PageHeader
                eyebrow="Contact"
                title={
                    <>
                        Tell us what you're <span className="text-brand">building</span>.
                    </>
                }
                sub="Share a few details about your project and we'll reply with a clear technical plan — scope, approach and honest timelines."
            />
            <section className="bg-paper py-20 sm:py-28">
                <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:px-8 lg:grid-cols-12 lg:px-16">
                    <Reveal className="lg:col-span-5">
                        <div className="space-y-4">
                            {INFO.map((item) => (
                                <div
                                    key={item.label}
                                    data-testid={`contact-info-${item.label.toLowerCase()}`}
                                    className="flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-6 shadow-card"
                                >
                                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-slate-50 text-brand">
                                        {item.logo ? (
                                            <img
                                                src={`https://cdn.simpleicons.org/${item.logo}`}
                                                alt=""
                                                loading="lazy"
                                                className="h-5 w-5"
                                            />
                                        ) : (
                                            <item.icon className="h-5 w-5" strokeWidth={1.7} />
                                        )}
                                    </div>
                                    <div>
                                        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400">
                                            {item.label}
                                        </p>
                                        {item.href ? (
                                            <a
                                                href={item.href}
                                                data-testid="contact-email-link"
                                                className="mt-1 block text-base font-semibold text-slate-900 transition-colors duration-300 hover:text-brand"
                                            >
                                                {item.value}
                                            </a>
                                        ) : (
                                            <p className="mt-1 text-base font-semibold text-slate-900">{item.value}</p>
                                        )}
                                        <p className="mt-1 text-sm text-slate-500">{item.note}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Reveal>
                    <Reveal delay={0.12} className="lg:col-span-7">
                        <div className="rounded-2xl border border-slate-200 bg-white p-7 shadow-card sm:p-10">
                            <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-brand">
                                New enquiry
                            </p>
                            <h2 className="mt-2 font-display text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
                                Start a Project
                            </h2>
                            <p className="mt-2 mb-8 text-sm text-slate-500">
                                A few details and we'll reply with a clear technical plan.
                            </p>
                            <ContactForm />
                        </div>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
